// Largeur commune des modales de création (publication, story) sur PC : deux colonnes lisibles quelle que soit la
// taille d'écran — 768 px dès md, 896 px à partir de xl (toujours bornée à la fenêtre − 1.5 rem par le Dialog).
export const PC_COMPOSER_MODAL = "sm:max-w-2xl md:max-w-3xl xl:max-w-4xl";
